import * as React from "react";
import type { SVGProps } from "react";
const SvgMic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1V0zm8 9a1 1 0 1 0-2 0zm-1 2h1zm-7 7v-1zm-7-7H4zm1-2a1 1 0 1 0-2 0zm5 13a1 1 0 1 0 2 0zm-3-1a1 1 0 1 0 0 2zm8 2a1 1 0 1 0 0-2zM12 0a4 4 0 0 0-2.828 1.172l1.414 1.414A2 2 0 0 1 12 2zM9.172 1.172A4 4 0 0 0 8 4h2a2 2 0 0 1 .586-1.414zM8 4v8h2V4zm0 8a4 4 0 0 0 1.172 2.828l1.414-1.414A2 2 0 0 1 10 12zm1.172 2.828A4 4 0 0 0 12 16v-2a2 2 0 0 1-1.414-.586zM12 16a4 4 0 0 0 2.828-1.172l-1.414-1.414A2 2 0 0 1 12 14zm2.828-1.172A4 4 0 0 0 16 12h-2a2 2 0 0 1-.586 1.414zM16 12V4h-2v8zm0-8a4 4 0 0 0-1.172-2.828l-1.414 1.414A2 2 0 0 1 14 4zm-1.172-2.828A4 4 0 0 0 12 0v2a2 2 0 0 1 1.414.586zM18 10v2h2v-2zm0 2a6 6 0 0 1-1.757 4.243l1.414 1.414A8 8 0 0 0 20 12zm-1.757 4.243A6 6 0 0 1 12 18v2a8 8 0 0 0 5.657-2.343zM12 18a6 6 0 0 1-4.243-1.757l-1.414 1.414A8 8 0 0 0 12 20zm-4.243-1.757A6 6 0 0 1 6 12H4a8 8 0 0 0 2.343 5.657zM6 12v-2H4v2zm5 7v4h2v-4zm-3 5h8v-2H8z"
    />
  </svg>
);
export default SvgMic;
